import { render, staticRenderFns } from "./eod-translations.vue?vue&type=template&id=f9aa68ec"
import script from "./eod-translations.vue?vue&type=script&lang=js"
export * from "./eod-translations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports